export default __webpack_public_path__ + "static/media/sticker-by.679b937c.png";